import { EmbedBlock } from "graphql/generated-types";
import React from "react";

const EmbedBlock = ({ block }: { block: EmbedBlock }) => {
	return (
		<div className="container">
			<div className="aspect-video responsive-object" dangerouslySetInnerHTML={{ __html: block.embed! }} />
		</div>
	);
};

export default EmbedBlock;
